/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
// import Signup from '@/views/SignUp.vue';
import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';
import Profile from '@/views/Profile.vue';
import Submission from '@/components/Submission.vue';
import Submissions from '@/views/Submissions.vue';
import Appointments from '@/views/Appointments.vue';
import AuthGuard from '@/router/auth-guard.js';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } 
      return { x: 0, y: 0 }
    
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: AuthGuard,
    },
    /*
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    }, */
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter: AuthGuard,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting - a different way of importing a page / path
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      component: About,
      beforeEnter: AuthGuard,
    },
    {
      path: '/appointments',
      name: 'Appointments',
      component: Appointments,
      beforeEnter: AuthGuard,
    },
    {
      path: '/submissions',
      name: 'Submissions',
      component: Submissions,
      beforeEnter: AuthGuard,
    },
    {
      path: '/submission/:guid',
      name: 'Submission',
      component: Submission,
      props: true,
      beforeEnter: AuthGuard,
    },
  ],
});
